@use "foundation/colors";
@use "foundation/responsive";

.applet-limit-warning {
  font-weight: bold;

  &.header {
    text-align: center;
    font-size: 0.8125em; // 13px

    margin-top: -2em; // 32px

    @include responsive.tablet-and-up {
      display: none;
    }
  }
}

.applet-limit-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 48px;
  gap: 16px;

  background-color: colors.$day;
  font-weight: 600;
  font-size: 16px;
  color: colors.$primary-eerie-black;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    white-space: nowrap;
    flex-shrink: 0;
    height: 54px;
    padding: 16px 28px;
    border: 4px solid rgba(34, 34, 34, 0.1);
    border-radius: 64px;
    background: none;
    font-weight: 700;
    font-size: 16px;
    color: colors.$primary-eerie-black;
    cursor: pointer;

    svg {
      width: 16px;
      height: 16px;
      path { fill: colors.$primary-eerie-black; }
    }
  }

  @include responsive.phone {
    flex-direction: column;
    text-align: center;
    padding: 24px;

    button {
      height: auto;
      padding: 12px 24px;
    }
  }
}
